import TubingModel from "../entities/TubingModel";
import ODataResponse from "../entities/ODataResponse";
import BaseRepository from "./BaseRepository";
import { TubingFlwBaselineModel } from "../entities";

export class TubingRepo extends BaseRepository {
  async getDetails(id: string, oDataQuery: string = ""): Promise<TubingModel> {
    const url = `/OData/Tubings(${id})?expand=Company,Inspections`;
    const response = await this.client.get(url);
    return this.handleResponse<TubingModel>(response)!;
  }

  async getTubings(oDataQuery: string = ""): Promise<ODataResponse<TubingModel>> {
    const url = `/OData/Tubings/?$count=true&${oDataQuery}`;
    const response = await this.client.get(url);
    return this.handleResponse<ODataResponse<TubingModel>>(response)!;
  }

  async updateDetails(id: string, data: TubingModel): Promise<boolean | undefined> {
    const url = `/Tubing/${id}`;
    const response = await this.client.post(url, data);
    return this.handleResponse(response);
  }

  async addTubing(data: TubingModel): Promise<boolean | undefined> {
    const url = `/Tubing/Insert`;
    const response = await this.client.post(url, data);
    return this.handleResponse(response);
  }

  async delete(tubingId: number): Promise<boolean> {
    const url = `Tubing/${tubingId}/Delete`;
    const response = await this.client.post(url);
    return response.success;
  }

  async getTubingFlwBaseline(id: number) {
    const url = `Tubing/${id}/TubingFlwBaseline`;
    const response = await this.client.get(url);
    return this.handleResponse<TubingFlwBaselineModel[]>(response);
  }

  async addTubingBaselinePoint(id: number, position: number, wallThickness: number) {
    const url = `Tubing/${id}/TubingFlwBaseline/Add`;
    const body = { position, wallThickness };
    const response = await this.client.post(url, body);
    return this.handleResponse<TubingFlwBaselineModel>(response);
  }

  async updateTubingBaselinePoint(id: number, cpId: number, position: number, wallThickness: number) {
    const url = `Tubing/${id}/TubingFlwBaseline/Update/${cpId}`;
    const body = { position, wallThickness };
    const response = await this.client.put(url, body);
    const handled = this.handleResponse(response);
    return handled !== undefined;
  }

  async deleteTubingBaselinePoint(id: number, cpId: number) {
    const url = `Tubing/${id}/TubingFlwBaseline/Delete/${cpId}`;
    const response = await this.client.delete(url);
    const handled = this.handleResponse(response);
    return handled !== undefined;
  }

  async getFlwBaselineChart(id: number) {
    const url = `Tubing/${id}/TubingFlwBaseline/Chart`;
    const response = await this.client.get<{ position: number; wallThickness: number }[]>(url);
    return this.handleResponse<{ position: number; wallThickness: number }[]>(response);
  }

  async uploadMillCert(id: number, file: File) {
    const url = `Tubing/${id}/MillCert`;
    const formData = new FormData();
    formData.append('file', file);
    const response = await this.client.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    const handled = this.handleResponse(response);
    return handled !== undefined;
  }

  async downloadMillCert(id: number): Promise<Blob | null> {
    const url = `Tubing/${id}/MillCert`;
    const response = await this.client.get<Blob>(url, { responseType: 'blob' });
    if (response.success && response.data) return response.data as Blob;
    return null;
  }

  async deleteMillCert(id: number) {
    const url = `Tubing/${id}/MillCert`;
    const response = await this.client.delete(url);
    const handled = this.handleResponse(response);
    return handled !== undefined;
  }
}

export default TubingRepo;
